import { FC } from 'react';

import { TableStyled } from './Table.styles';
import { TableProps } from './Table.types';

import TableContextProvider from './TableContext';

const Table: FC<TableProps> = ({ children, css }) => {
  return (
    <TableContextProvider>
      <TableStyled css={{ ...css }} cellSpacing={0}>
        {children}
      </TableStyled>
    </TableContextProvider>
  );
};

export default Table;
